import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Layout from '../components/layout/Layout';
import { MemberService } from '../api/services/MemberService';
import { useUIStore } from '../store/uiStore';
import { useNavigate } from 'react-router-dom';
import { hashPassword } from '../utils';
import Logo from '../assets/Logo/unogo.png';

const ChangePassword = () => {
	const { t } = useTranslation();
	const params = new URLSearchParams(window.location.search);
	const token = params.get('token');
	localStorage.setItem('token', token || '');
	const { showToast } = useUIStore();
	const navigate = useNavigate();
	const [newPassword, setNewPassword] = useState('');
	const [repeatPassword, setRepeatPassword] = useState('');
	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		if (!newPassword || !repeatPassword) {
			showToast('warning', t('login.pleaseInputNewPasswordAndConfirmPassword'));
			return;
		}
		if (newPassword !== repeatPassword) {
			showToast('warning', t('login.newPasswordAndConfirmPasswordNotMatch'));
			return;
		}
		try {
			const res = await MemberService.forgetPassword({
				body: {
					newPassword: await hashPassword(newPassword),
					repeatPassword: await hashPassword(repeatPassword),
				},
			});
			if (res) {
				showToast('success', t('messages.operationSuccess'));
				navigate('/login');
			}
		} catch (err) {}
	};
	return (
		<Layout showHeader={false} showBottomNav={false}>
			<div className="min-h-screen flex flex-col justify-center items-center bg-gradient-to-br from-indigo-400 to-purple-500">
				{/* 顶部头像/图标 */}
				<div className="w-20 h-20 bg-white rounded-full flex items-center justify-center mb-6 shadow-lg">
					<img src={Logo} alt="logo" className="w-20 h-20" />
				</div>
				<div className="bg-white rounded-2xl shadow-xl p-8 w-full max-w-sm">
					<h2 className="text-2xl font-bold text-gray-800 text-center mb-6">
						{t('login.changePassword', '修改密码')}
					</h2>
					<form onSubmit={handleSubmit} className="space-y-5">
						<div>
							<label className="block text-gray-700 font-medium mb-2">
								{t('login.newPassword', '新密码')}
							</label>
							<input
								type="password"
								value={newPassword}
								onChange={(e) => setNewPassword(e.target.value)}
								className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-400"
								placeholder={t('login.enterNewPassword', '请输入新密码')}
								required
								autoFocus
							/>
						</div>
						<div>
							<label className="block text-gray-700 font-medium mb-2">
								{t('login.repeatPassword', '确认密码')}
							</label>
							<input
								type="password"
								value={repeatPassword}
								onChange={(e) => setRepeatPassword(e.target.value)}
								className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-400"
								placeholder={t('login.reenterNewPassword', '请再次输入新密码')}
								required
							/>
						</div>
						<button
							type="submit"
							className="w-full bg-gradient-to-r from-purple-500 to-blue-600 text-white py-3 rounded-lg font-semibold text-lg shadow hover:opacity-90 active:scale-95 transition"
						>
							{t('login.editPassword', '提交')}
						</button>
					</form>
				</div>
			</div>
		</Layout>
	);
};
export default ChangePassword;
